import { render, staticRenderFns } from "./PayrollGroups.vue?vue&type=template&id=b189441e&scoped=true"
import script from "./PayrollGroups.vue?vue&type=script&lang=js"
export * from "./PayrollGroups.vue?vue&type=script&lang=js"
import style0 from "./PayrollGroups.vue?vue&type=style&index=0&id=b189441e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189441e",
  null
  
)

export default component.exports